export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/sort_asc@2x.png";